import { RootState } from '@next/core-lib/app';

export interface DeliveryModuleState extends RootState {
  deliveries?: Delivery[];
  selectedDeliveryId: number;
  isLoaded: boolean;
  startDate: string;
  endDate: string;
}

export enum DeliveryOriginEnum {
  START = 'start',
  PLATFORM = 'Platform',
  MANUAL = 'Manual',
}

export enum ProductTypeEnum {
  RAWPRODUCT = 'RawProduct',
  MIXEDPRODUCT = 'MixedProduct',
}

export interface Delivery {
  id: number;
  deliveryOrigin: DeliveryOriginEnum;
  externalDeliveryId: string;
  deliveryType: string;
  deliveryDate: string;
  customerId: number;
  shipToId: number;
  deliveryLines: DeliveryLine[];
}

export interface DeliveryLine {
  id: string;
  externalUniqueIdentifier: string;
  externalProductId: string;
  productTitle: string;
  productType: ProductTypeEnum;
  unitVolumeType: string;
  unitsDelivered: number;
  unitsRemaining: number;
  isActive: boolean;
  currency: string;
  unitNettoPrice?: number;
  kgDelivered?: number;
  barnId?: number;
  externalInvoiceId: string;
  invoiceDate: string;
  vatPercentage?: number;
  showInFinalSetup?: boolean;
  brutoAmount?: number;
  nettoAmount?: number;
  vatAmount?: number;
  brutoUnitPrice?: number;
  baseQuantity?: number;
}

export interface ActiveDelivery {
  deliveryId: number;
  deliveryOrigin: DeliveryOriginEnum;
  activeDeliveryLineExternalUniqueIdentifiers: string[];
}

export interface DeliveryDataRow {
  deliveryDate: string;
  deliveryId: string;
  invoiceDate: string;
  invoiceId: string;
  externalUniqueIdentifier: string;
  product: string;
  isActive: boolean;
  data: Delivery;
  showInFinalSetup?: boolean;
}
